export function loadAllAssets(k) {
    // --- Sprites ---
    k.loadSprite("bag", "/sprites/bag.png");
    k.loadSprite("tiles", "/sprites/tiles.png", { sliceX: 25, sliceY: 25 });
    k.loadSprite("monkeySprite", "/sprites/monkey_sprite.png", {
        sliceX: 3,
        sliceY: 1,
        anims: {
            idle: { frames: [0, 1, 2, 1], loop: true, speed: 5 }
        },
    });

    k.loadSprite("bean", "/sprites/bean.png");
    k.loadSprite("ghosty", "/sprites/ghosty.png");
    k.loadSprite("tga", "/sprites/tga.png");
    k.loadSprite("puddle", "/sprites/puddle.png");


    // UI Elements
    k.loadSprite("arrowCursor", "/sprites/tiny_swords/UI Elements/UI Elements/Cursors/cursor01.png");
    k.loadSprite("pointerCursor", "/sprites/tiny_swords/UI Elements/UI Elements/Cursors/cursor02.png");
    k.loadSprite("forbidenCursor", "/sprites/tiny_swords/UI Elements/UI Elements/Cursors/cursor03.png");
    k.loadSprite("tileSelectCursor", "/sprites/tiny_swords/UI Elements/UI Elements/Cursors/cursor04.png");
    k.loadSprite("targetCursorOff", "/sprites/targetCursorOff.png");
    k.loadSprite("targetCursorOn", "/sprites/targetCursorOn.png");
    k.loadSprite("cross_mark_o", "/sprites/cross_mark-o.png");
    k.loadSprite("players_buttons_1", "/sprites/players_button_1.png", {
        sliceX: 2,
        sliceY: 2,
    });
    k.loadSprite("killMoutMout", "/sprites/tiny_swords/UI Elements/killmoutmout.png");
    k.loadSprite("SmallRedSquareButton_Regular", "/sprites/tiny_swords/UI Elements/UI Elements/Buttons/SmallRedSquareButton_Regular.png");
    k.loadSprite("SmallRedSquareButton_Pressed", "/sprites/tiny_swords/UI Elements/UI Elements/Buttons/SmallRedSquareButton_Pressed.png");
    k.loadSprite("actionCard", "/sprites/tiny_swords/UI Elements/UI Elements/Papers/actionCard.png");
    k.loadSprite("cursor_playable_card_on_slot", "/sprites/tiny_swords/UI Elements/UI Elements/Cursors/Cursor_04.png", {
        slice9: {
            left: 8,
            right: 8,
            top: 8,
            bottom: 8,
        }
    });

    // CARD ILLUSTATION
    k.loadSprite("PAN", "/sprites/card_illustration/PAN.png");
    k.loadSprite("EN_JOUE", "/sprites/card_illustration/EN_JOUE.png");
    k.loadSprite("RECTIFIER_TIR_DROITE", "/sprites/card_illustration/RECTIFIER_TIR_DROITE.png");
    k.loadSprite("RECTIFIER_TIR_GAUCHE", "/sprites/card_illustration/RECTIFIER_TIR_GAUCHE.png");
    k.loadSprite("BANZAI", "/sprites/card_illustration/BANZAI.png");
    k.loadSprite("PALME_ARRIERE", "/sprites/card_illustration/PALME_ARRIERE.png");
    k.loadSprite("PALME_AVANT", "/sprites/card_illustration/PALME_AVANT.png");
    k.loadSprite("EN_AVANT_MARCHE", "/sprites/card_illustration/EN_AVANT_MARCHE.png");
    k.loadSprite("TIREUR_DELITE", "/sprites/card_illustration/TIREUR_DELITE.png");
    k.loadSprite("DOUBLE_VISEUR", "/sprites/card_illustration/DOUBLE_VISEUR.png");
    k.loadSprite("CANARDAGE", "/sprites/card_illustration/CANARDAGE.png");
    k.loadSprite("DISPERSION", "/sprites/card_illustration/DISPERSION.png");
    k.loadSprite("PLANQUE", "/sprites/card_illustration/PLANQUE.png");

    // CARD PICTO
    k.loadSprite("PAN_PICTO", "/sprites/card_picto/PAN.png");
    k.loadSprite("EN_JOUE_PICTO", "/sprites/card_picto/EN_JOUE.png");
    k.loadSprite("RECTIFIER_TIR_DROITE_PICTO", "/sprites/card_picto/RECTIFIER_TIR_DROITE.png");
    k.loadSprite("RECTIFIER_TIR_GAUCHE_PICTO", "/sprites/card_picto/RECTIFIER_TIR_GAUCHE.png");
    k.loadSprite("BANZAI_PICTO", "/sprites/card_picto/BANZAI.png");
    k.loadSprite("PALME_ARRIERE_PICTO", "/sprites/card_picto/PALME_ARRIERE.png");
    k.loadSprite("PALME_AVANT_PICTO", "/sprites/card_picto/PALME_AVANT.png");
    k.loadSprite("EN_AVANT_MARCHE_PICTO", "/sprites/card_picto/EN_AVANT_MARCHE.png");
    k.loadSprite("TIREUR_DELITE_PICTO", "/sprites/card_picto/TIREUR_DELITE.png");
    k.loadSprite("DOUBLE_VISEUR_PICTO", "/sprites/card_picto/DOUBLE_VISEUR.png");
    k.loadSprite("CANARDAGE_PICTO", "/sprites/card_picto/CANARDAGE.png");

    // Backgrounds (Kaplay loads backgrounds as sprites)
    k.loadSprite("menu_background", "/backgrounds/menu_bg.png");

    // --- Sounds ---
    k.loadSound("monkey_scream", "/sounds/monkey.mp3");
    k.loadSound("pistol_shoot", "/sounds/pistol_shoot.mp3");
    k.loadSound("bloodSplat1", "/sounds/blood_splat1.mp3");
    k.loadSound("waterSplash", "/sounds/water_splash.mp3");
    k.loadSound("monkey_sound", "/sounds/monkey_sound.mp3");
    k.loadSound("sheep", "/sounds/sheep.mp3");
    k.loadSound("sheepSceam", "/sounds/sheepScreem2.mp3");
    k.loadSound("bush_touch", "/sounds/bush_touch.mp3");
    k.loadSound("cobblestone1", "/sounds/cobblestone1.mp3");
    k.loadSound("cobblestone2", "/sounds/cobblestone2.mp3");
    k.loadSound("cobblestone3", "/sounds/cobblestone3.mp3");
    k.loadSound("sniper_reload", "/sounds/sniper_reload.mp3");
    k.loadSound("sniper_shoot", "/sounds/sniper_shoot.mp3");
    k.loadSound("shootgun", "/sounds/shootgun.mp3");
    k.loadSound("jump", "/sounds/jump-boing.mp3");
    k.loadSound("grass_step", "/sounds/grass_step.mp3");
    k.loadSound("card_flip_1", "/sounds/card_flip_1.mp3");
    k.loadSound("card_flip_2", "/sounds/card_flip_2.mp3");
    k.loadSound("card_tap", "/sounds/card_tap.mp3");

    // --- Fonts ---
    k.loadFont("lilita", "/fonts/LilitaOne-Regular.ttf");
    k.loadFont("babySheepFont", "/fonts/BabySheep-0WXe9.ttf");
    k.loadFont("nunito", "/fonts/Nunito-VariableFont_wght.ttf");

    // GAME SCENE
    k.loadSprite("sheep", "/sprites/tiny_swords/Units/sheep.png",{
        sliceX: 22, sliceY: 1,
        anims:{
            idle: {from: 0, to:5, loop: true, speed:9},
            grass: {from: 6, to:17, loop: true, speed:9},
            run: {from: 18, to:21, loop: true, speed:9},
        }
    });
    k.loadSprite("woodtable", "/sprites/tiny_swords/UI Elements/UI Elements/Wood Table/WoodTable.png",{sliceX: 7, sliceY: 7});
    k.loadSprite("banner", "/sprites/tiny_swords/UI Elements/UI Elements/Banners/Banner.png",{sliceX: 7, sliceY: 7});
    k.loadSprite("woodslot", "/sprites/tiny_swords/UI Elements/UI Elements/Wood Table/WoodTable_Slots.png");
    k.loadSprite("tileShadow", "/sprites/tiny_swords/Terrain/Tileset/Shadow.png");
    k.loadSprite("clouds1", "/sprites/tiny_swords/Terrain/Decorations/Clouds/Clouds_01.png");
    k.loadSprite("rock3", "/sprites/tiny_swords/Terrain/Decorations/Rocks/Rock3.png");
    k.loadSprite("clouds1", "/sprites/tiny_swords/Terrain/Decorations/Clouds/Clouds_01.png");
    k.loadSprite("clouds3", "/sprites/tiny_swords/Terrain/Decorations/Clouds/Clouds_03.png");
    k.loadSprite("Tilemap_color1", "/sprites/tiny_swords/Terrain/Tileset/Tilemap_color1.png",{sliceX: 9, sliceY: 6});
    k.loadSprite("Tilemap_color2", "/sprites/tiny_swords/Terrain/Tileset/Tilemap_color2.png",{sliceX: 9, sliceY: 6});
    k.loadSprite("Tilemap_color3", "/sprites/tiny_swords/Terrain/Tileset/Tilemap_color3.png",{sliceX: 9, sliceY: 6});
    k.loadSprite("Tilemap_color4", "/sprites/tiny_swords/Terrain/Tileset/Tilemap_color4.png",{sliceX: 9, sliceY: 6});
    k.loadSprite("Tilemap_color5", "/sprites/tiny_swords/Terrain/Tileset/Tilemap_color5.png",{sliceX: 9, sliceY: 6});
    k.loadSprite("Tree1", "/sprites/tiny_swords/Terrain/Resources/Wood/Trees/Tree1.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6}
        }
    });
    k.loadSprite("Tree2", "/sprites/tiny_swords/Terrain/Resources/Wood/Trees/Tree2.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6}
        },
    });
    k.loadSprite("Tree3", "/sprites/tiny_swords/Terrain/Resources/Wood/Trees/Tree3.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6}
        }
    });
    k.loadSprite("Tree4", "/sprites/tiny_swords/Terrain/Resources/Wood/Trees/Tree4.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6}
        }
    });
    k.loadSprite("stump1", "/sprites/tiny_swords/Terrain/Resources/Wood/Trees/Stump 1.png");
    k.loadSprite("foam", "/sprites/tiny_swords/Terrain/Tileset/Water_Foam.png",{
        sliceX: 16, sliceY: 1,
        anims:{
            idle: {from: 0, to:15, loop: true, speed:10}
        }
    });
    k.loadSprite("bushe1", "/sprites/tiny_swords/Terrain/Decorations/Bushes/Bushe5.png",{
        sliceX: 14, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6},
            jump: {from: 8, to:13, loop: true, speed:25}
        }
    });
    k.loadSprite("bushe2", "/sprites/tiny_swords/Terrain/Decorations/Bushes/Bushe2.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6}
        }
    });
    k.loadSprite("bushe3", "/sprites/tiny_swords/Terrain/Decorations/Bushes/Bushe3.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            idle: {from: 0, to:7, loop: true, speed:6}
        }
    });
    k.loadSprite("waterRock1", "/sprites/tiny_swords/Terrain/Decorations/Rocks in the Water/Water Rocks_01.png",{
        sliceX: 16, sliceY: 1,
        anims:{
            idle: {from: 0, to:15, loop: true, speed:6}
        }
    });
    k.loadSprite("waterRock2", "/sprites/tiny_swords/Terrain/Decorations/Rocks in the Water/Water Rocks_02.png",{
        sliceX: 16, sliceY: 1,
        anims:{
            idle: {from: 0, to:15, loop: true, speed:6}
        }
    });
    k.loadSprite("waterRock3", "/sprites/tiny_swords/Terrain/Decorations/Rocks in the Water/Water Rocks_03.png",{
        sliceX: 16, sliceY: 1,
        anims:{
            idle: {from: 0, to:15, loop: true, speed:6}
        }
    });
    k.loadSprite("waterRock4", "/sprites/tiny_swords/Terrain/Decorations/Rocks in the Water/Water Rocks_04.png",{
        sliceX: 16, sliceY: 1,
        anims:{
            idle: {from: 0, to:15, loop: true, speed:6}
        }
    });
    k.loadSprite("littleDust", "/sprites/tiny_swords/Particle FX/Dust_01.png",{
        sliceX: 8, sliceY: 1,
        anims:{
            spawn: {from: 0, to:7, loop: false, speed:10}
        }
    });
}